import { BottomSheet } from 'doctornow-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const MaternityGuideBottomSheet = ({ isOpen, onClose }: Props) => {
  return (
    <BottomSheet
      type='vertical'
      title={
        <>
          사후피임약은
          <br />
          비대면 처방이 어려워요
        </>
      }
      description='질염, 생리통 등 다른 증상은 비대면 진료가 가능해요!'
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      buttons={[
        {
          label: '확인했어요',
          variant: 'primary',
          onClick: onClose,
        },
      ]}
    >
      <div className='flex justify-center'>
        <img
          src='https://media.doctornow.co.kr/web_diagnosis_warning.webp'
          alt='contraceptive guide'
          className='h-[160px] w-[312px] object-contain'
        />
      </div>
    </BottomSheet>
  );
};

export default MaternityGuideBottomSheet;
